<template>
  <div class="venue-description">
      <p>
        <span v-html="formattedString"></span>
        <span v-show="isShow">
        <a href="" v-show="!isReadMore" v-on:click="triggerReadMore($event, true)">{{ strings.readmore }}</a>
        <a href="" v-show="isReadMore" v-on:click="triggerReadMore($event, false)">{{ strings.readless }}</a>
        </span>
      </p>
      <!-- Translation notice -->

        <div class="gtranslate-bar" v-show="show_GG_translate">
            <div class="note" v-show="!isLanguageSame">
                <div v-show="!translated">
                    <p class="note__info"><MPSpinner v-show="isTranslating"/>{{ strings.translateto }} {{ selectedLang }}. <span class="note__link" @click="translateDescription">{{ strings.clickhere }}</span></p>
                    <img src="../assets/img/icon-google-translate.svg" alt="Google Translate" class="note__img">
                </div>
                <div v-show="translated">
                    <p class="note__info"><MPSpinner v-show="isTranslating"/>{{ strings.translatedto }} {{ selectedLang }} {{ strings.basedonyourlang}}. <span class="note__link" @click="showOrigLanguage">{{ strings.resettooriginal }}</span></p>
                    <img src="../assets/img/icon-google-translate.svg" alt="Google Translate" class="note__img">
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import MPSpinner from './Spinner';
    export default {
        props: ['description', 'strings', 'value'],
        data() {
            return {
                vdescription: '',
                isReadMore: false,
                maxChars : 300,
                isTranslated: false,
                showOriginalLanguage: '',
                show_GG_translate: false,
                langlist: {
                     en: 'English',
                     da: 'Dansk' ,
                     fi: 'Suomi',
                     fr: 'Français' ,
                     de: 'Deutsch' ,
                     it: 'Italiano' ,
                     lv: 'Latviešu' ,
                     ru: 'Русский' ,
                     es: 'Español' ,
                     sv: 'Svenska' ,
                     zh: '中文 (简体)'
                }
            }
        },
        components: {
            MPSpinner
        },
        watch: {
            description: function(value) {
             this.vdescription = value;
             this.show_GG_translate = this.$store.state.venueInfo.default_language ? false : true;
            },
            value: function() {
            }
        },
        computed: {
            formattedString: function(){
            	let val_container = this.vdescription;

            	if(!this.isReadMore && this.vdescription.length > this.maxChars){
            		val_container = val_container.substring(0,this.maxChars) + ' ... ';
            	}

            	return(val_container);
            },
            selectedLang: function() {
                let l = this.$store.state.selectedLang;
                let lname =  this.langlist[l];
                return lname;
            },
            isShow(){
                return this.vdescription.length > this.maxChars;
            },
            isTranslating(){
                return this.$store.state.isTranslating;
            },
            isLanguageSame: function() {
                if ( this.$store.state.selectedLang == this.$store.state.detectedLanguage) {
                    return true;
                } else {
                    return false;
                }
            },
            translated: function() {
                return this.$store.state.isTranslated;
            }
        },
        methods: {
    		triggerReadMore: function(e, b){
    			e.preventDefault();
    			this.isReadMore = b;
    		},
            translateDescription: function() {
                this.$store.dispatch('gTranslate', { text: this.vdescription, lang: this.$store.state.selectedLang });
                this.vdescription = this.$store.state.translatedLanguage;
                this.$store.commit('isTranslated', true);
            },
            showOrigLanguage: function() {
                this.vdescription = this.$store.state.venueInfo.description;
                this.$store.commit('isTranslated', false);
            }
        }
    }
</script>

